import { createSelector, createSlice } from "@reduxjs/toolkit";
import { classifications as initialState } from "../initialState";
import { selectUserSelectedClassificationSelector } from "../selectors/classificationsSelectors";
import { selectAllRegistration } from "./registrationSlice";

export const slice = createSlice({
    name: "classifications",
    initialState,
    reducers: {
        // There is an api call in UpdateOutdated.js that resets the classifications
        // if raceCondition is hit on submission
        updateClassifications: (state, action) => action.payload,
    },
});

// actions
export const { updateClassifications } = slice.actions;

// selectors

// same as getClassifications
export const selectAllClassifications = (state) => state.classifications;

export const selectUserSelectedClassification = createSelector(
    [
        (state) => selectAllRegistration(state),
        (state) => selectAllClassifications(state),
    ],
    (registration, classifications) =>
        selectUserSelectedClassificationSelector(registration, classifications),
);

export default slice.reducer;
